"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditInventorySubjectCommand = void 0;
const validator_1 = require("@leavy/validator");
const StepCommand_1 = require("../../common/command/StepCommand");
const OnboardingId_1 = require("../../common/domain/OnboardingId");
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
let EditInventorySubjectCommand = class EditInventorySubjectCommand extends StepCommand_1.StepCommand {
    constructor() {
        super(...arguments);
        this.onboardingId = OnboardingId_1.OnboardingId.HL;
    }
};
__decorate([
    (0, validator_1.Equals)(OnboardingId_1.OnboardingId.HL),
    __metadata("design:type", String)
], EditInventorySubjectCommand.prototype, "onboardingId", void 0);
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], EditInventorySubjectCommand.prototype, "subjectId", void 0);
__decorate([
    (0, validator_1.IsString)(),
    __metadata("design:type", String)
], EditInventorySubjectCommand.prototype, "subjectName", void 0);
EditInventorySubjectCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "edit_inventory_subject",
    })
], EditInventorySubjectCommand);
exports.EditInventorySubjectCommand = EditInventorySubjectCommand;
//# sourceMappingURL=EditInventorySubjectCommand.js.map